import Button from "components/atoms/Button";
import BuyNowButton from "components/atoms/BuyNowButton";
import CashBackNotify from "components/atoms/CashBackNotify";
import Checkbox from "components/atoms/Checkbox";
import Heading from "components/atoms/Heading";
import Icon from 'components/atoms/Icon';
import IconCheck from "components/atoms/IconCheck";
import Link from "components/atoms/Link";
import Loading from "components/atoms/Loading";
import LoadingState from "components/atoms/LoadingState";
import QuantityButton from "components/atoms/QuantityButton";
import Text from "components/atoms/Text";
import CarouselItem from "components/molecules/Carousel/CarouselItem";
import Coupon from "components/molecules/Coupon";
import LargeCoupon from "components/molecules/Coupon/LargeCoupon";
import { GrayText } from "components/molecules/Coupon/componentStyledCoupon";
import DeliveryProvinceSelection from "components/molecules/DeliveryProvinceSelection";
import GiftList from "components/molecules/GiftList";
import List from "components/molecules/List";
import ListItem from "components/molecules/List/ListItem";
import LoadingBox from "components/molecules/LoadingBox";
import Orientation from "components/molecules/Orientation";
import Productfeature from "components/molecules/Productfeature";
import ReserveProductDesc from "components/molecules/ReserveProductDesc";
import StringToHtml from "components/molecules/StringToHtml";
import Rcrating from "components/molecules/rcrating";
import FormSupply from "components/organisms/FormSupply";
import Modal from "components/organisms/Modal";
import ModalBody from "components/organisms/Modal/Body";
import ModalHeader from "components/organisms/Modal/Header";
import Wrap from "components/organisms/Wrap";
import { removeProductInLocalCart } from "constants/addtocart";
import { CART_NAME } from "constants/cart";
import colors, { alphaColor } from "constants/colors";
import { BASE_URL } from "constants/env";
import {
  removeGameCouponLocalStoreFlow,
  removeItemCouponLocalStoreFlow
} from "constants/global";
import { COMMON_LOADING_SIZE } from "constants/loading";
import {
  ERROR_TYPES,
  LOCATION_DELIVERY_NAME,
  findAvalableIndexStock,
  getLocalStorageByName,
  getProductsLocationDeliveryStore,
  removeLocalStorageByName,
  setDefaultLocationDeliveryStore
} from "constants/location";
import {
  ButtonConfirm,
  ButtonConfirmWrapper,
  ConfirmWrapper,
  DeliveryProvinceSelectionLabel,
  LoadingInfo,
  RatingContainer,
  RatingReviewCounting,
  TextConfirm,
  TitleConfirm,
  WrapLoading
} from "constants/styledComponent";
import { useSelector } from "hooks/useApp";
import Cookies from "js-cookie";
import React, { useEffect, useMemo, useState } from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import ReactPixel from "react-facebook-pixel";
import ReactGA from "react-ga";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { saveLocationBuying } from "redux/actions/location/locationBuying";
import {
  onChangeStatusIsHaveSetupService,
  updateCartProducts
} from "redux/actions/products/cart";
import { setIsOutStock } from "redux/reducers/view/outstock";
import styled from "styled-components/macro";
import { Navigation, SwiperOptions } from "swiper";
import { Swiper, SwiperSlide } from 'swiper/react';
import { ViewItemProductEventTypes, trackingAddToCartEvent, trackingViewItemEvent } from 'utils/trackingGA';
import { formatMoneyD, isExternal, processCashbackString } from "utils/utils-common";
import "./index.scss";

interface ProductInfomationProps {
  detail?: any;
  step2?: any;
  passQuantity: (quantity: number) => void;
  onToggleInfoBuyingForm: () => void;
  onScrollToRatingSection: () => void;
}

const ProductInfomation: React.FC<ProductInfomationProps> = ({
  detail,
  step2,
  passQuantity,
  onToggleInfoBuyingForm,
  onScrollToRatingSection,
}: ProductInfomationProps) => {
  const [selected, setSelected] = useState(1);
  const [cashBackListChecks, setCashBackListChecks] = useState<CashBack[]>();
  const [loadingInformation, setLoadingInformation] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const dispatch = useDispatch();
  const { cart } = useSelector(state => state.products);
  // const { cities } = useSelector(state => state.general);
  const { locationBuying } = useSelector(state => state);
  const { productCities } = useSelector(state => state.general);
  const history = useHistory();
  const [isBuyingClick, setIsBuyingClick] = useState(false);
  /**
   * Feature Coupon 7/7/2021
   * https://jira.3forcom.com/browse/DE-868
   */
  const [selectedCoupon, setSelectedCoupon] = useState<CouponItem>();
  const [copiedCoupon, setCopiedCoupon] = useState<CouponItem>();
  const [showListCouponModal, setShowListCouponModal] = useState<boolean>(
    false,
  );
  const [coupons, setCoupons] = useState<CouponItem[]>();

  const onChangeQuantity = (product = null, quantity: number, sign: string) => {
    setQuantity(quantity);
    passQuantity(quantity);
  };

  const setCart = async (cashBackIds: number[]): Promise<LocalCartItem[]> =>
    new Promise((resolve, reject) => {
      try {
        if (detail) {
          // PROCESS LIST CASHBACK CHECK LIST:
          const localCart = localStorage.getItem("cart");

          if (localCart) {
            let LOCAL_CART: LocalCartItem[] = JSON.parse(localCart);
            LOCAL_CART = LOCAL_CART.map(item => ({
              ...item,
              cashBackIds,
            }));
            localStorage.setItem("cart", JSON.stringify(LOCAL_CART));
            dispatch(onChangeStatusIsHaveSetupService(detail.product_id));
            resolve(LOCAL_CART);
          } else {
            //
          }
        }
      } catch (error) {
        reject(error);
      }
    });

  const updateCart = async () => {
    if (
      detail.product_type_id === 1 ||
      detail.product_type_id === 2 ||
      detail.product_type_id === 3 ||
      detail?.is_buy
    ) {
      dispatch(updateCartProducts(detail, quantity));
      setIsBuyingClick(true);
    } else {
      onToggleInfoBuyingForm();
    }

    if (cashBackListChecks) {
      if (
        cashBackListChecks.length &&
        cashBackListChecks.find(
          (item: CashBack) =>
            !item.status && (item.type === 1 || item.type === 3),
        )
      ) {
        const activeItems = cashBackListChecks.filter(
          item => item.status && (item.type === 1 || item.type === 3),
        );
        const deactiveItems = cashBackListChecks.filter(
          item => !item.status && (item.type === 1 || item.type === 3),
        );
        let arr: number[] = [];
        if (cashBackListChecks.length === deactiveItems.length) {
          // empty
          arr = [];
        } else if (cashBackListChecks.length === activeItems.length) {
          // all
          arr = activeItems.map(item => item.cashBackId);
        } else if (deactiveItems.length && activeItems.length) {
          // active only - not deactive
          arr = activeItems.map(item => item.cashBackId);
        } else {
          // active only - not deactive
          arr = activeItems.map(item => item.cashBackId);
        }
        setCart(arr).then(data => {
          if (data) {
            // console.log('successful set cart', data);
          }
        });
      }
    }

    // add current product to localStorage:
    localStorage.setItem(
      "prevcartitemId",
      JSON.stringify({
        id: detail.id,
        isError: false,
      }),
    );

    // ga tracking
    if (
      ReactGA.plugin &&
      ReactGA.plugin.execute &&
      typeof ReactGA.plugin.execute === "function"
    ) {
      // ReactGA.plugin.execute("ecommerce", "addItem", {
      //   id: detail.model, // Transaction ID. Required.
      //   name: detail.name, // Product name. Required.
      //   sku: detail.model, // SKU/code.
      //   price: Number(detail.price), // Unit price.
      //   category: detail.name_product_type, // Category or variation.
      //   quantity,
      // });
      // ReactGA.plugin.execute("ecommerce", "send", null);
      // ReactGA.plugin.execute("ecommerce", "clear", null);

      // ec:addtocart
      // ReactGA.plugin.execute("ec", "addProduct", {
      //   id: detail.model, // Transaction ID. Required.
      //   name: detail.name, // Product name. Required.
      //   sku: detail.model, // SKU/code.
      //   price: Number(detail.price), // Unit price.
      //   revenue: Number(detail.price), // Unit price.
      //   ...(detail.name_product_type
      //     ? { category: detail.name_product_type }
      //     : {}), // Category or variation.
      //   quantity,
      //   list: "Product Detail Information", // List name.
      // });
      ReactGA.plugin.execute("ec", "setAction", "add");
    }

    const value = Object.keys(detail.discount).length > 0
      ? detail.discount.discount_type === 1
        ?
        Math.round(
          (detail.price *
            (1 - detail.discount.discount_value / 100)) /
          1000,
        ) * 1000
        : Math.round(
          (detail.price - detail.discount.discount_value) / 1000,
        ) * 1000
      : Math.round(detail.price / 1000) * 1000;

    const items = detail.same_product.filter((sp: any) => sp.slug === detail.slug)
      ?.map((item: any, index: number): ViewItemProductEventTypes => {
        const discount = ((Math.round(item.price / 1000) * 1000) * (item.discount?.discount_value?.split(".")[0] || 0)) / 100;
        return {
          item_id: item.slug,
          item_name: item.name,
          index,
          discount,
          affiliation: "Daikin-E",
          price: Math.round(item.price / 1000) * 1000,
          quantity: 1,
          item_category: item.name_product_type || '',
          ...(item.id === selected ? {
            coupon: coupons?.map((coupon) => coupon.code).join(', '),
          } : {})
        }
      });

    trackingAddToCartEvent({
      currency: 'VND',
      value,
      items,
    });

    // fbPixelId tracking
    if (ReactPixel.fbq && typeof ReactPixel.fbq === "function") {
      ReactPixel.fbq("track", "AddToCart", {
        id: detail.model, // Transaction ID. Required.
        name: detail.name, // Product name. Required.
        sku: detail.model, // SKU/code.
        price: Number(detail.price), // Unit price.
        category: detail.name_product_type, // Category or variation.
        quantity,
        content_type: 'product', // required property
        content_ids: detail.model // required property
      });
    }
  };

  const [hasErrorBuying, setHasErrorBuying] = useState<{
    id: string;
    error: any;
    title: any;
  }>();

  useEffect(() => {
    const { loading, error, data } = cart;
    setLoadingInformation(loading);
    if (!loading && isBuyingClick) {
      if (error) {
        const { code: errorCode, title } = error.response.data.errors[0];
        if (errorCode) {
          if (errorCode === "521") {
            setHasErrorBuying({
              id: ERROR_TYPES.LIMIT_PROMOTION,
              error: error.response.data.errors[0],
              title:
                "Bạn đã đạt giới hạn số lượng sản phẩm khuyến mãi dành cho nhân viên.",
            });
          } else if (errorCode === "599") {
            setHasErrorBuying({
              id: ERROR_TYPES.SAME_TYPE,
              error: error.response.data.errors[0],
              title,
            });
          }
        }
        removeProductInLocalCart(detail.id);
      } else if (data && Object.entries(data).length > 0) {
        if (!temporaryOutOfStock && detail.product_parent_type_id !== 4) {
          const currentLocationDelivery = getProductsLocationDeliveryStore();

          // save location delivery:
          localStorage.setItem(
            LOCATION_DELIVERY_NAME,
            JSON.stringify(
              currentLocationDelivery
                ? {
                  cart: [
                    ...(currentLocationDelivery.cart
                      ? currentLocationDelivery.cart.filter(
                        item => item.productId !== detail.id,
                      )
                      : []),
                    {
                      productId: detail.id,
                      location:
                        productCitiesName[currentSelectedDeliveryItemIndex] &&
                        productCitiesName[currentSelectedDeliveryItemIndex]
                          .name,
                    },
                  ],
                }
                : {
                  cart: [
                    {
                      productId: detail.id,
                      location:
                        productCitiesName[currentSelectedDeliveryItemIndex] &&
                        productCitiesName[currentSelectedDeliveryItemIndex]
                          .name,
                    },
                  ],
                },
            ),
          );
        }
        history.push("/gio-hang");
      }
      setIsBuyingClick(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cart]);

  // Reset cashback change:
  useEffect(() => {
    localStorage.removeItem("cashListChanges");
    if (!getLocalStorageByName(CART_NAME))
      removeLocalStorageByName(LOCATION_DELIVERY_NAME);

    // check selected coupon:
    const coupon = sessionStorage.getItem("_coupon_");
    if (coupon) {
      const _coupon: CouponItem = JSON.parse(coupon);
      // kiểm tra _coupon có trong list thì active:
      if (coupons) {
        const findItem = coupons.find(
          item => item.code === _coupon.code && item.id === _coupon.id,
        );
        if (findItem) {
          setSelectedCoupon(findItem);
        }
      }
    }
  }, [coupons]);

  const [temporaryOutOfStock, setTemporaryOutOfStock] = useState(false);

  useEffect(() => {
    if (detail) {
      const cashBacks = (detail as APICartProductDetail).cashBacks;
      if (cashBacks && cashBacks.length) {
        setCashBackListChecks(
          cashBacks.map(
            (cbitem): CashBack => ({
              cashBackId: cbitem.cashBackTranslations[0].cashBackId,
              status: cbitem.active ? cbitem.active : true,
              type: cbitem.type,
            }),
          ),
        );
      }
      setTemporaryOutOfStock(detail.out_stock === 1);
    }
  }, [detail]);

  // suplies modal start
  const [suplliesModal, setSuplliesModal] = useState(false);
  const openSuppliesModal = () => {
    setSuplliesModal(!suplliesModal);
  };

  useEffect(() => {
    if (detail) {
      const { same_product } = detail;

      if (same_product.length > 0) {
        const index = same_product.findIndex(p => p.id === detail.id);
        if (index > -1) {
          setSelected(same_product[index].id);
        } else {
          setSelected(same_product[0].id);
        }
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [detail]);

  const handleChangeCheckbox = (id: number) => {
    if (cashBackListChecks) {
      let copy = [...cashBackListChecks];
      copy = copy.map(item =>
        item.cashBackId === id
          ? {
            ...item,
            status: !item.status,
          }
          : item,
      );
      setCashBackListChecks(copy);
    }
  };

  const [isShowDesc, setIsShowDesc] = useState<boolean>(false);
  const onToggleClick = () => {
    setIsShowDesc(!isShowDesc);
  };

  const [
    currentSelectedDeliveryItemIndex,
    setCurrentSelectedDeliveryItemIndex,
  ] = useState<number>(0);

  // PRODUCT CITIES:
  const [productCitiesName, setProductCitiesName] = useState([]);
  const [loadingProductCity, setLoadingProductCity] = useState(false);
  useEffect(() => {
    const { data, loading } = productCities;
    setLoadingProductCity(loading);
    if (data && data.length > 0) {
      setProductCitiesName(
        data.map((item: any) => ({
          id: item.city.id,
          name: item.city.name,
          status: item.status,
        })),
      );
      setAllOutStock(data.every((item: any) => item.status !== 1));
    }
  }, [productCities]);

  const checkToSetProductCitiesMatchWithLocationBuying = () => {
    setLoadingProductCity(true);
    const findIndexSelectedItem = productCitiesName.findIndex(
      city => city.name === locationBuying.name && city.status === 1,
    );

    // neu tim thay defaultLocation trong ds & con hang:
    if (findIndexSelectedItem > -1 && detail) {
      setCurrentSelectedDeliveryItemIndex(findIndexSelectedItem);
      setHasErrorBuying({
        id: ERROR_TYPES.DEFAULT_LOCATION_OUT_STOCK,
        error: null,
        title: null,
      });
    } else {
      // tim location khac trong list:
      const findOtherIndex = findAvalableIndexStock(
        productCitiesName,
        detail.product_id,
      );

      if (findOtherIndex > -1) {
        // Tim thay location khac:

        // update product in localLocationDelivery storage by id
        //
        // 1. Show thông báo tỉnh/thành ban đầu chọn đã hết hàng.
        // 2. Vui lòng chọn lại tỉnh/thành tổng để cập nhật lại tỉnh/thành còn hàng.
        setHasErrorBuying({
          id: ERROR_TYPES.DEFAULT_LOCATION_OUT_STOCK,
          error: null,
          title: `Tỉnh thành của bạn <strong>${locationBuying.name}</strong> tạm hết hàng. <br/>Vui lòng thay đổi tỉnh thành khác để cập nhật tình trạng hàng.`,
        });
        setCurrentSelectedDeliveryItemIndex(-1);
      } else {
        // out stock:
      }
    }

    setLoadingProductCity(false);
  };

  const [allOutStock, setAllOutStock] = useState<boolean>();

  useEffect(() => {
    if (locationBuying) {
      checkToSetProductCitiesMatchWithLocationBuying();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationBuying]);

  useEffect(() => {
    setLoadingProductCity(true);
    if (locationBuying && productCitiesName && productCitiesName.length > 0) {
      const currentLocationDelivery = getProductsLocationDeliveryStore();
      if (currentLocationDelivery && currentLocationDelivery.cart) {
        const findItem = currentLocationDelivery.cart.find(
          item => item.productId === detail.product_id,
        );

        if (findItem) {
          const findIndexHasLocationBuying = productCitiesName.findIndex(
            item => item.name === findItem.location,
          );

          setCurrentSelectedDeliveryItemIndex(
            findIndexHasLocationBuying > -1 ? findIndexHasLocationBuying : -1,
          );
          setLoadingProductCity(false);
        } else {
          checkToSetProductCitiesMatchWithLocationBuying();
        }
      } else {
        checkToSetProductCitiesMatchWithLocationBuying();
      }
    } else {
      // mặc định là item 0;
    }
    setLoadingProductCity(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productCitiesName]);

  const handleChangeProvince = (list: LocationItem[], locationName: any) => {
    const findedIndexOfSelectedItem = list.findIndex(
      item => item.name === locationName,
    );

    if (findedIndexOfSelectedItem > -1) {
      const resultItem = {
        id: list[findedIndexOfSelectedItem].id,
        name: list[findedIndexOfSelectedItem].name,
      };
      setDefaultLocationDeliveryStore(resultItem);
      dispatch(saveLocationBuying(resultItem));
      toast.info("Tỉnh thành đã được lưu");
    } else {
      setCurrentSelectedDeliveryItemIndex(
        findAvalableIndexStock(list, detail.product_id),
      );
    }
  };

  useEffect(() => {
    if (
      detail &&
      locationBuying &&
      productCitiesName &&
      !!productCitiesName.length
    ) {
      const showCouponData = detail.showCoupons as ShowCoupon[];

      setCoupons(
        showCouponData
          .filter(
            item =>
              item.date_ended &&
              item.code &&
              item.short_description &&
              item.apply_cities.includes(
                productCitiesName[currentSelectedDeliveryItemIndex] &&
                productCitiesName[currentSelectedDeliveryItemIndex].id,
              ),
          )
          .map((c: ShowCoupon) => ({
            id: c.id,
            label: c.short_description,
            code: c.code,
            desc: c.description,
            expiredDate: new Date(c.date_ended).toLocaleDateString(),
          })) || [],
      );
    }
  }, [
    currentSelectedDeliveryItemIndex,
    detail,
    locationBuying,
    productCitiesName,
  ]);

  const confirmReplaceCoupon = (coupon: CouponItem, gameCode: CouponCookie) => {
    confirmAlert({
      customUI: ({ onClose }) => (
        <ConfirmWrapper>
          <TitleConfirm>Xác nhận</TitleConfirm>
          <TextConfirm>
            Thay thế khuyến mãi&nbsp;
            <strong>{gameCode.v1}</strong>&nbsp;từ vòng xoay thay bằng khuyến
            mãi&nbsp;
            <strong>{coupon.code}</strong>?
          </TextConfirm>
          <ButtonConfirmWrapper>
            <ButtonConfirm
              type="button"
              size="xsmall"
              variant="danger"
              onClick={(): void => onClose()}
            >
              Không
            </ButtonConfirm>
            <ButtonConfirm
              type="button"
              size="xsmall"
              variant="primary"
              onClick={(): void => {
                setSelectedCoupon(coupon);
                sessionStorage.setItem("_coupon_", JSON.stringify(coupon));
                sessionStorage.setItem("_cabh_", coupon.code); // codeAppliedByHand
                removeGameCouponLocalStoreFlow();
                onClose();
              }}
            >
              Đồng ý
            </ButtonConfirm>
          </ButtonConfirmWrapper>
        </ConfirmWrapper>
      ),
    });
  };

  const confirmChangeCoupon = (coupon: CouponItem) => {
    confirmAlert({
      customUI: ({ onClose }) => (
        <ConfirmWrapper>
          <TitleConfirm>Xác nhận</TitleConfirm>
          <TextConfirm>
            {selectedCoupon && coupon.id === selectedCoupon.id ? (
              <>
                Bỏ áp dụng mã khuyến mãi&nbsp;
                <strong>{selectedCoupon.code}</strong>
                &nbsp;?
              </>
            ) : (
              <>
                Áp dụng mã khuyến mãi&nbsp;
                <strong>{coupon.code}</strong>
                &nbsp;?
              </>
            )}
          </TextConfirm>
          <ButtonConfirmWrapper>
            <ButtonConfirm
              type="button"
              size="xsmall"
              variant="danger"
              onClick={(): void => onClose()}
            >
              Không
            </ButtonConfirm>
            <ButtonConfirm
              type="button"
              size="xsmall"
              variant="primary"
              onClick={(): void => {
                if (selectedCoupon) {
                  if (coupon.id === selectedCoupon.id) {
                    setSelectedCoupon(undefined);
                    removeItemCouponLocalStoreFlow();
                  } else {
                    setSelectedCoupon(coupon);
                    sessionStorage.setItem("_coupon_", JSON.stringify(coupon));
                    sessionStorage.setItem("_cabh_", coupon.code); // codeAppliedByHand
                  }
                }
                onClose();
              }}
            >
              Đồng ý
            </ButtonConfirm>
          </ButtonConfirmWrapper>
        </ConfirmWrapper>
      ),
    });
  };

  const sameProductDisplay = (
    detail: any,
    p: any,
  ): { name: string; price: any } =>
    detail && {
      name: p.name.split("-").length > 1 ? p.name.split("-")[1].trim() : "",
      price:
        ((detail.product_type_id !== 4 && //sky-air
          detail.product_type_id !== 5 && //sky-air
          detail.product_type_id !== 6 && //sky-air
          detail.product_type_id !== 7 && //sky-air
          detail.product_type_id !== 8 && //sky-air
          detail.product_parent_type_id !== 4) || //con sky-air
          detail?.is_buy)
          ? p.discount && Object.keys(p.discount).length > 0
            ? p.discount.discount_type === 1
              ? window.formatMoney(
                Math.round(
                  (p.price * (1 - p.discount.discount_value / 100)) / 1000,
                ) * 1000,
              )
              : Math.round((p.price - p.discount.discount_value) / 1000) * 1000
            : window.formatMoney(Math.round(p.price / 1000) * 1000)
          : "",
    };

  const productPrice = useMemo(
    () =>
      ((detail &&
        detail.product_type_id !== 4 && //sky-air
        detail.product_type_id !== 5 && //sky-air
        detail.product_type_id !== 6 && //sky-air
        detail.product_type_id !== 7 && //sky-air
        detail.product_type_id !== 8 && //sky-air
        detail.product_parent_type_id !== 4) || //con sky-air
        detail?.is_buy) &&
      detail.price && (
        <div className="o-productinformation_price">
          {Object.keys(detail.discount).length > 0
            ? detail.discount.discount_type === 1
              ? window.formatMoney(
                Math.round(
                  (detail.price *
                    (1 - detail.discount.discount_value / 100)) /
                  1000,
                ) * 1000,
              )
              : Math.round(
                (detail.price - detail.discount.discount_value) / 1000,
              ) * 1000
            : window.formatMoney(Math.round(detail.price / 1000) * 1000)}
        </div>
      ),
    [detail],
  );

  const productOriginalPrice = useMemo(
    () =>
      detail &&
      Object.keys(detail.discount).length > 0 &&
      detail.discount.discount_value > 0 && (
        <div className="o-productinformation_promotionprice-left">
          <div className="o-productinformation_promotionprice-originPrice">
            <del>{`${window.formatMoney(
              Math.round(detail.price / 1000) * 1000,
            )}`}</del>{" "}
            <label>{detail.discount.discount_type === 1 ?
              `(-${detail.discount.discount_value.split(".")[0]}%)` :
              `(-${Math.round(detail?.discount?.discount_value.split(".")[0] / detail?.price.split(".")[0] * 100)}%)`}</label>
          </div>
        </div>
      ),
    [detail],
  );

  // Tracking view_item
  useEffect(() => {
    if (step2 && detail) {
      const value = Object.keys(detail.discount).length > 0
        ? detail.discount.discount_type === 1
          ?
          Math.round(
            (detail.price *
              (1 - detail.discount.discount_value / 100)) /
            1000,
          ) * 1000
          : Math.round(
            (detail.price - detail.discount.discount_value) / 1000,
          ) * 1000
        : Math.round(detail.price / 1000) * 1000;

      const item_list = {
        ids: step2.related_products?.map((item: any) => item.slug),
        names: step2.related_products?.map((item: any) => item.name),
      };

      const items = detail.same_product.filter((sp: any) => sp.slug === detail.slug)
        ?.map((item: any, index: number): ViewItemProductEventTypes => {
          const discount = ((Math.round(item.price / 1000) * 1000) * (item.discount?.discount_value?.split(".")[0] || 0)) / 100;
          return {
            item_id: item.slug,
            item_name: item.name,
            index,
            discount,
            affiliation: "Daikin-E",
            price: Math.round(item.price / 1000) * 1000,
            quantity: 1,
            item_category: item.name_product_type || '',
            ...(item.id === selected ? {
              coupon: coupons?.map((coupon) => coupon.code).join(', '),
              item_list_id: item_list.ids,
              item_list_name: item_list.names,
            } : {})
          }
        });

      trackingViewItemEvent({
        currency: 'VND',
        value,
        items
      });

    }
  }, [step2]);

  const isProductToBuy = useMemo(
    () =>
      (detail && detail.product_type_id === 1) ||
      detail.product_type_id === 2 ||
      detail.product_type_id === 3 ||
      detail?.is_buy,
    [detail],
  );

  const isOutStock = useMemo(
    () =>
      isProductToBuy &&
      (allOutStock ||
        temporaryOutOfStock ||
        (hasErrorBuying &&
          hasErrorBuying.id &&
          hasErrorBuying.id === ERROR_TYPES.DEFAULT_LOCATION_OUT_STOCK &&
          (hasErrorBuying.error || hasErrorBuying.title))),
    [allOutStock, hasErrorBuying, isProductToBuy, temporaryOutOfStock],
  );

  useEffect(() => {
    detail && dispatch(setIsOutStock(detail.id, isProductToBuy && isOutStock));
  }, [detail, dispatch, isOutStock, isProductToBuy]);

  const params = {
    // Provide Swiper class as props
    Swiper,
    // Add modules you need
    modules: [Navigation],
    slidesPerView: "auto",
    autoHeight: true,
    spaceBetween: 16,
    pagination: false,
    navigation: true,
    rebuildOnUpdate: true,
  } as SwiperOptions;

  const finnalPrice = useMemo(() => Object.keys(detail.discount).length > 0
    ? detail.discount.discount_type === 1
      ?
      Math.round(
        (detail.price *
          (1 - detail.discount.discount_value / 100)) /
        1000,
      ) * 1000
      : Math.round(
        (detail.price - detail.discount.discount_value) / 1000,
      ) * 1000
    : Math.round(detail.price / 1000) * 1000,
    [detail]);

  return (
    detail && (
      <div className="o-productinformation">
        <div className="o-productinformation_detail">
          <div className="o-productinformation_info">
            <Heading
              type="h1"
              modifiers={["no-margin-bottom", "reset-line-height"]}
              size="sm"
            >
              {detail.name}
            </Heading>
            <Text modifiers={["grayscale"]} size="sm">
              Model: {detail.model}
            </Text>
            <RatingContainer>
              <Rcrating
                defaultValue={(detail.rating && detail.rating.avg) || 0}
                size={18}
                colorActive={colors.tangerine}
                disabled
              />
              <RatingReviewCounting onClick={onScrollToRatingSection}>
                {(detail.rating && detail.rating.count) || 0} đánh giá
              </RatingReviewCounting>
            </RatingContainer>
            <div className="o-productinformation_wrapprice">
              {productPrice}
              {productOriginalPrice}
            </div>
          </div>

          {detail.tags.length > 0 && (
            <div className="o-productinformation_tags">
              {detail.tags &&
                detail.tags.map((tag, index) => {
                  return (
                    <div key={index} className="o-productinformation_tag">
                      <Text modifiers={["primary"]} size="sm">
                        {tag.name}
                      </Text>
                    </div>
                  );
                })}
            </div>
          )}

          {detail.same_product.length > 0 && (
            <div className="o-productinformation_type">
              <Orientation>
                {detail.same_product.map((p, index) => (
                  <Link href={`/san-pham/${p.slug}`} key={index}>
                    {detail.same_product.length > 1 ? (
                      <IconCheck
                        type="radio"
                        name="a-select-icon"
                        value={p.id}
                        display={sameProductDisplay(detail, p)}
                        selected={selected}
                      />
                    ) : null}
                  </Link>
                ))}
              </Orientation>
            </div>
          )}

          {isProductToBuy ? (
            !isOutStock ? (
              // mua ngay case:
              <>
                <div className="o-productinformation_quantity">
                  <div className="o-productinformation_quantity-input">
                    <QuantityButtonExtended
                      onChangeQuantity={onChangeQuantity}
                      value={quantity}
                      modifiers={["normal"]}
                      name="adjustment-buying-quantity"
                      product={detail}
                    />
                  </div>
                  <div className="o-productinformation_quantity-button">
                    <BuyNowButton
                      type="buynow"
                      className="buynow-inline-btn" // 🚫 class "buynow-inline-btn" đang dùng ở ScrollTabProductDetail component để xác định móc hiển thị/ẩn nút fixed buynow ở mobile
                      handleClick={updateCart}
                      disabled={currentSelectedDeliveryItemIndex < 0}
                      {...(detail.reserve
                        ? {
                          ctaText: detail.reserve_text,
                        }
                        : {})}
                    />
                  </div>
                </div>
                {detail.reserve ? (
                  <ReserveProductDesc
                    content={detail.reserve_short_description}
                    className="detail-style"
                  />
                ) : null}
              </>
            ) : (
              <BuyNowButton
                type="outstock"
                className="buynow-inline-btn" // 🚫 class "buynow-inline-btn" đang dùng ở ScrollTabProductDetail component để xác định móc hiển thị/ẩn nút fixed buynow ở mobile
              />
            )
          ) : (
            // tu van case:
            <div className="o-productinformation_quantity">
              <div className="o-productinformation_quantity-button">
                <Button
                  variant="primary"
                  modifiers={["rounded"]}
                  onClick={updateCart}
                >
                  TƯ VẤN
                </Button>
              </div>
            </div>
          )}

          {hasErrorBuying &&
            ((hasErrorBuying.id &&
              hasErrorBuying.id === ERROR_TYPES.LIMIT_PROMOTION) ||
              hasErrorBuying.id === ERROR_TYPES.SAME_TYPE) && (
              <ErrorPanel>
                <StringToHtml content={hasErrorBuying.title} />
              </ErrorPanel>
            )}

          {loadingProductCity ? (
            <LoadingState />
          ) : (
            !allOutStock &&
            hasErrorBuying &&
            (hasErrorBuying.id &&
              hasErrorBuying.id === ERROR_TYPES.DEFAULT_LOCATION_OUT_STOCK &&
              (hasErrorBuying.error || hasErrorBuying.title)) && (
              <ErrorPanel>
                <StringToHtml content={hasErrorBuying.title} />
              </ErrorPanel>
            )
          )}

          {
            detail?.catalogue_url && (
              <div
                className="o-productinformation_catalogue"
              >
                <Button variant="outline-noHover" onClick={() => window.open(isExternal(detail.catalogue_url) ? detail.catalogue_url : BASE_URL + detail.catalogue_url, '_blank')}>
                  <Icon iconName="catalogue" />
                  <Text>Catalogue</Text>
                </Button>
              </div>
            )
          }

          {
            productPrice && finnalPrice >= 3000000 && (
              <div className="o-productinformation_interesRate">
                <span className="o-productinformation_interesRate-label">Lãi suất 0%</span>
                <span className="o-productinformation_interesRate-price">{formatMoneyD((finnalPrice / 12))}</span>
                <span className="o-productinformation_interesRate-unit">đ</span>
                <span className="o-productinformation_interesRate-month">{`/tháng`}</span>
                <span>trong 12 tháng</span>
              </div>
            )
          }

          {detail.product_parent_type_id !== 4 &&
            (loadingProductCity ? (
              <LoadingBox label="Đang tải tỉnh thành..." />
            ) : productCitiesName &&
              productCitiesName.length > 0 &&
              !allOutStock ? (
              <>
                <DeliveryProvinceSelectionLabel>
                  Tỉnh thành đang chọn:
                </DeliveryProvinceSelectionLabel>
                <DeliveryProvinceSelection
                  list={productCitiesName}
                  currentIndex={currentSelectedDeliveryItemIndex}
                  onChange={item => {
                    if (typeof item === "boolean" && item === false) {
                      toast.error("Tỉnh thành này đã hết hàng");
                    } else {
                      handleChangeProvince(productCitiesName, item && item);
                    }
                  }}
                  hideTitle
                  selectLabel="Thay đổi tỉnh thành khác"
                />
              </>
            ) : null)}

          {coupons ? (
            <div className="coupons-slider-wrapper">
              <div className="coupons-slider">
                {!!coupons.length && (
                  <ExtendedGrayText>Mã Giảm Giá</ExtendedGrayText>
                )}
                <div className="m-carousel">
                  <Swiper {...params}>
                    {coupons.map((coupon, index) => (
                      <SwiperSlide key={index}>
                        <CarouselItem>
                          <Coupon
                            selected={
                              (selectedCoupon &&
                                coupon.id === selectedCoupon.id) ||
                              false
                            }
                            onShow={() => {
                              setShowListCouponModal(true);
                            }}
                            data={coupon}
                            parentBgColor="white"
                            type="small"
                          >
                            {coupon.label}
                          </Coupon>
                        </CarouselItem>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
            </div>
          ) : (typeof coupons === "object" && !coupons.length) ||
            coupons === undefined ? null : (
            <WrapLoading>
              <Loading widthHeight={COMMON_LOADING_SIZE} />
              <LoadingInfo>Đang tải khuyến mãi</LoadingInfo>
            </WrapLoading>
          )}

          {coupons && (
            <Modal
              isOpen={showListCouponModal}
              onCloseRequest={() => {
                setShowListCouponModal(false);
              }}
              resetModal
              balanceHeaderStyle
              className="coupons-modal"
            >
              <ModalHeader
                onCloseRequest={() => {
                  setShowListCouponModal(false);
                }}
              >
                <Heading modifiers={["center", "no-margin-bottom"]} type="h3">
                  Mã Giảm Giá
                </Heading>
              </ModalHeader>
              <ModalBody>
                {false ? (
                  <LoadingBox label={`Đang tải danh sách khuyến mãi`} />
                ) : (
                  <div className="coupons-slider">
                    {coupons.map((coupon, index) => (
                      <LargeCoupon
                        key={index}
                        copied={
                          (copiedCoupon && coupon.id === copiedCoupon.id) ||
                          false
                        }
                        onCopied={() => {
                          setCopiedCoupon(coupon);
                          setTimeout(() => {
                            setCopiedCoupon(undefined);
                          }, 2000);
                        }}
                        data={coupon}
                        parentBgColor="white"
                        type="large"
                        selected={
                          (selectedCoupon && coupon.id === selectedCoupon.id) ||
                          false
                        }
                        applyButton={
                          <ExtendedButton
                            size="xsmall"
                            variant={
                              !selectedCoupon ||
                                (selectedCoupon &&
                                  selectedCoupon.id !== coupon.id)
                                ? "primary"
                                : "danger"
                            }
                            onClick={() => {
                              const gameCoupon = Cookies.get("_cg_");
                              if (gameCoupon) {
                                confirmReplaceCoupon(
                                  coupon,
                                  JSON.parse(gameCoupon),
                                );
                              } else {
                                if (!selectedCoupon) {
                                  setSelectedCoupon(coupon);
                                  sessionStorage.setItem(
                                    "_coupon_",
                                    JSON.stringify(coupon),
                                  );
                                  sessionStorage.setItem("_cabh_", coupon.code); // codeAppliedByHand
                                } else {
                                  confirmChangeCoupon(coupon);
                                }
                                setShowListCouponModal(true);
                              }
                            }}
                          >
                            {!selectedCoupon ||
                              (selectedCoupon && selectedCoupon.id !== coupon.id)
                              ? "Áp dụng"
                              : "Bỏ chọn"}
                          </ExtendedButton>
                        }
                      >
                        <StringToHtml content={coupon.desc} />
                      </LargeCoupon>
                    ))}
                  </div>
                )}
              </ModalBody>
            </Modal>
          )}

          {detail.gift_info || detail.cashBacks ? (
            <>
              <div className="o-productinformation_policy_body o-productinformation_policy_body-lighten-theme">
                <div className="o-productinformation_policy_body_labelheading">
                  Khuyến mãi
                </div>
                <Wrap
                  style={{
                    border: `1px solid ${colors.richElectricBlue}`,
                    borderTop: "none",
                    padding: "15px 15px",
                  }}
                >
                  {/* Cashbacks Type */}
                  {detail.cashBacks &&
                    detail.cashBacks.length &&
                    detail.cashBacks
                      .filter(
                        (filterCBDetailItem: APICashBack) =>
                          filterCBDetailItem.type === 2,
                      )
                      .map((mapCBDetailItem: APICashBack, index: number) => (
                        <GiftList
                          key={index}
                          data={
                            mapCBDetailItem.cashBackTranslations[0].description
                          }
                          hasIcon={true}
                        />
                      ))}

                  {/* Gift List */}
                  <GiftList data={detail.gift_info} hasIcon={true} />

                  {/* Services Type */}
                  <Wrap className="o-productinformation_policy_body-checkListCash">
                    {cashBackListChecks &&
                      cashBackListChecks.filter(
                        item => item.type === 1 || item.type === 3,
                      ).length ? (
                      <CashBackNotify />
                    ) : null}
                    {cashBackListChecks &&
                      detail.cashBacks &&
                      cashBackListChecks
                        .filter(item => item.type === 1 || item.type === 3)
                        .map((item, index) => {
                          const findItem = (detail.cashBacks as APICashBack[]).find(
                            o =>
                              o.cashBackTranslations[0].cashBackId ===
                              item.cashBackId,
                          );
                          if (findItem) {
                            const tempCbk = findItem.cashBackTranslations[0]
                              .description
                              ? processCashbackString(
                                findItem.cashBackTranslations[0].description,
                                "",
                              )
                              : "";

                            return tempCbk ? (
                              <Checkbox
                                key={index}
                                checked={item.status}
                                type="checkbox"
                                name={`cashback-checkbox-item-${findItem.productId}-${item.cashBackId}`}
                                value={tempCbk}
                                display={tempCbk}
                                noSpacingLeft
                                onChange={() => {
                                  handleChangeCheckbox(item.cashBackId);
                                }}
                              />
                            ) : null;
                          }
                          return null;
                        })}
                  </Wrap>
                </Wrap>
              </div>
            </>
          ) : null}
        </div>

        {detail.description && (
          <>
            <div
              className={`o-productinformation_description-sp ${isShowDesc ? "show" : ""
                }`}
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: detail.description || "",
                }}
              ></div>
            </div>
            <div
              onClick={onToggleClick}
              className={`o-productinformation_viewmore-sp ${isShowDesc ? "show" : ""
                } `}
            >
              {isShowDesc ? "Thu gọn" : "Xem thêm đặc điểm nổi bật"}
            </div>
          </>
        )}

        <div className="o-productinformation_functionair-sp">
          {detail.features.length > 0 &&
            detail.features.map(
              (f: any, i: number) =>
                f.image && (
                  <Productfeature
                    imgSrc={`${BASE_URL}${f.image}`}
                    title={f.name}
                    description={f.description}
                    key={i}
                  />
                ),
            )}
          <div className="o-productinformation_line"></div>
        </div>

        {/* POLICY */}
        <div className="o-productinformation_policy">
          <div className="o-productinformation_policy_body">
            <List modifiers={["icon"]}>
              <ListItem iconName="percent">
                Chính hãng&nbsp;
                <strong>Daikin Vietnam</strong>.
              </ListItem>
              <ListItem iconName="exchange">
                <strong>300 bước kiểm tra</strong>
                &nbsp;nghiêm ngặt trước khi xuất xưởng.
              </ListItem>
              <ListItem iconName="policy-mobile">
                Lắp đặt&nbsp;
                <strong>chuyên nghiệp</strong>
                &nbsp;theo chuẩn Daikin.&nbsp;
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://shop.daikin.com.vn/lap-dat-dieu-hoa-chuan-daikin"
                  className="blank_link"
                >
                  Tìm hiểu thêm
                </a>
              </ListItem>
              <ListItem iconName="delivery">
                <strong>Miễn phí</strong>&nbsp;vận chuyển.
              </ListItem>
              <ListItem iconName="wrench">
                Phí&nbsp;
                <strong
                  className="o-productinformation_policy_body-supplies"
                  onClick={openSuppliesModal}
                >
                  vật tư lắp đặt
                </strong>
                &nbsp;tạm tính.
              </ListItem>
            </List>
          </div>
        </div>
        {loadingInformation && <LoadingState />}
        {suplliesModal && (
          <FormSupply onToggleForm={() => openSuppliesModal(suplliesModal)} />
        )}
        {isBuyingClick && <LoadingState />}
      </div>
    )
  );
};

const QuantityButtonExtended = styled(QuantityButton)`
  width: 100%;
`;

const ExtendedGrayText = styled(GrayText)`
  font-size: 16px;
  font-weight: 600;
  padding-left: 3px;
  margin-top: 10px;
  margin-bottom: 5px;
`;

const ErrorPanel = styled.div`
  color: ${colors.pastelRed};
  font-size: 11px;
  margin-top: 1em;
  border-left: 3px solid ${colors.pastelRed};
  padding-left: 0.25em;
  background: ${alphaColor.topaz015};
  border: 2px solid ${colors.mikadoYellow};
  color: ${colors.pumpkin};
  border-radius: 1em;
  padding: 1em;
  margin-bottom: 1em;
`;

const ExtendedButton = styled(Button)`
  width: 124px;
  height: 24px;
  min-width: 0 !important;
  min-height: 0 !important;
`;

ProductInfomation.defaultProps = {};

export default ProductInfomation;
